export default __webpack_public_path__ + "static/media/remedy_coffee_1.d51b9bcb.png";